import script from "./BuilderView.vue?vue&type=script&setup=true&lang=js"
export * from "./BuilderView.vue?vue&type=script&setup=true&lang=js"

import "./BuilderView.vue?vue&type=style&index=0&id=302e31b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-302e31b2"]])

export default __exports__